__turbopack_context__.v({
  "dot-con": "latestInHdfc-module-scss-module__ziOeEG__dot-con",
  "dot-mb": "latestInHdfc-module-scss-module__ziOeEG__dot-mb",
  "dot-readtxt-mb": "latestInHdfc-module-scss-module__ziOeEG__dot-readtxt-mb",
  "img-tag-con": "latestInHdfc-module-scss-module__ziOeEG__img-tag-con",
  "lat-bottom-txt": "latestInHdfc-module-scss-module__ziOeEG__lat-bottom-txt",
  "lat-card": "latestInHdfc-module-scss-module__ziOeEG__lat-card",
  "lat-card-con": "latestInHdfc-module-scss-module__ziOeEG__lat-card-con",
  "lat-card-slider": "latestInHdfc-module-scss-module__ziOeEG__lat-card-slider",
  "lat-card-track": "latestInHdfc-module-scss-module__ziOeEG__lat-card-track",
  "lat-chev-txt-con": "latestInHdfc-module-scss-module__ziOeEG__lat-chev-txt-con",
  "lat-chevron-con": "latestInHdfc-module-scss-module__ziOeEG__lat-chevron-con",
  "lat-main-con": "latestInHdfc-module-scss-module__ziOeEG__lat-main-con",
  "lat-one-card": "latestInHdfc-module-scss-module__ziOeEG__lat-one-card",
  "lat-top-txt": "latestInHdfc-module-scss-module__ziOeEG__lat-top-txt",
  "lat-txt-con": "latestInHdfc-module-scss-module__ziOeEG__lat-txt-con",
  "lat-view-more": "latestInHdfc-module-scss-module__ziOeEG__lat-view-more",
  "latest-img": "latestInHdfc-module-scss-module__ziOeEG__latest-img",
  "one-lat-card-track": "latestInHdfc-module-scss-module__ziOeEG__one-lat-card-track",
  "tag-con": "latestInHdfc-module-scss-module__ziOeEG__tag-con",
});
